import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/home/excel.png'


const _withScopeId = n => (_pushScopeId("data-v-9e892a7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dispatch-table-container" }
const _hoisted_2 = { class: "table-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-title" }, "被派遣单位列表信息", -1))
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { class: "table-wrapper" }
const _hoisted_6 = {
  key: 0,
  style: {"margin":"0"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-grey" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("已归档 ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  style: {"margin":"0"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-green" }, null, -1))
const _hoisted_12 = {
  key: 2,
  style: {"margin":"0"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background":"#FFC53D"}
}, null, -1))
const _hoisted_14 = {
  key: 3,
  style: {"margin":"0"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background":"#8691A3"}
}, null, -1))
const _hoisted_16 = {
  key: 4,
  style: {"margin":"0"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-red" }, null, -1))
const _hoisted_18 = {
  key: 5,
  style: {"margin":"0"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background":"#FFC53D"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "export-icon",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportTable && _ctx.exportTable(...args))),
          title: "导出Excel",
          alt: "导出Excel"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_table, {
        data: _ctx.displayData,
        style: {"width":"100%"},
        "header-cell-class-name": "table-head",
        "row-style": { color: '#333' },
        border: "",
        onSortChange: _ctx.handleSortChange,
        "default-sort": { prop: 'claim_ratio', order: 'descending' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "序号",
            width: "70",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "被派遣单位",
            "min-width": "200",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "occupation",
            label: "可用工种",
            "min-width": "250",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.occupation, (item, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: index,
                  style: {"margin":"0","line-height":"1.8"}
                }, _toDisplayString(item.name + `（${item.level}类）`), 1))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "active_num",
            label: "在保人数",
            "min-width": "110",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "ratio_level3",
            label: "3类占比",
            "min-width": "100",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.ratio_level3 || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "ratio_level4",
            label: "4类占比",
            "min-width": "100",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.ratio_level4 || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "ratio_level5",
            label: "5类占比",
            "min-width": "100",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.ratio_level5 || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "claim_ratio",
            label: "出险率",
            "min-width": "100",
            align: "center",
            sortable: "custom"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.claim_ratio || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "fracture_ratio",
            label: "骨折率",
            "min-width": "100",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.fracture_ratio || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "pay_ratio",
            label: "理赔率",
            "min-width": "100",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.pay_ratio || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "report_num",
            label: "案件数量",
            "min-width": "110",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "create_time",
            label: "添加时间",
            "min-width": "180",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "status",
            label: "状态",
            "min-width": "110",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              (scope.row.is_archive == 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _hoisted_9))
                : (scope.row.status == '通过')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                      _hoisted_11,
                      _createTextVNode(_toDisplayString(scope.row.status), 1)
                    ]))
                  : (scope.row.status == '待审核')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                        _hoisted_13,
                        _createTextVNode(_toDisplayString(scope.row.status), 1)
                      ]))
                    : (scope.row.status == '驳回')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                          _hoisted_15,
                          _createTextVNode(_toDisplayString(scope.row.status), 1)
                        ]))
                      : (scope.row.status == '拒保')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                            _hoisted_17,
                            _createTextVNode(_toDisplayString(scope.row.status), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_18, [
                            _hoisted_19,
                            _createTextVNode(_toDisplayString(scope.row.status), 1)
                          ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSortChange"]),
      (_ctx.tableData.length > 5)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "view-more",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleViewMore && _ctx.toggleViewMore(...args)))
          }, _toDisplayString(_ctx.showAll ? '收起' : '查看更多'), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}